import parse from 'utils/parse';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'start-earning', 'desktop-carousel', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  slide: makeTestId('slide'),
});

const sizes = Object.freeze({
  active: {
    width: 230,
    height: 480,
  },
  inactive: {
    width: 205,
    height: 427,
  },
  spacing: 12,
});

export { testId, sizes };
